// The ten English language proficiency documentation types, in display order. Mirrors the
// ENGLISH_LANGUAGE_PROFICIENCY_DOCUMENTS_TYPES Angular constant in settings_module.js, which the
// admin-facing edit-english-documents directive still injects. Labels come from
// `settings.edit_documents.<type>`.
export const ENGLISH_LANGUAGE_PROFICIENCY_DOCUMENTS_TYPES = [
    'duolingo',
    'toefl_pbt',
    'ibt',
    'ielts',
    'pte',
    'act_compass',
    'accuplacer_esl',
    'eiken',
    'cefr',
    'other',
] as const;

// Only the US form requires city/state/zip, matching the old template's
// `ng-required="userProxy.country === 'US'"`.
export const US_COUNTRY_CODE = 'US';

export const MAX_ADDRESS_LINE_LENGTH = 60;
